import { render } from "./MassUpdater.vue?vue&type=template&id=324f5aba"
import script from "./MassUpdater.vue?vue&type=script&lang=js"
export * from "./MassUpdater.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__